import { FC, Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../organisms/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { selectUser, setAccessToken } from "@/app/auth/auth.slice";
import { ProfileListModal } from "../organisms/ProfileListModal";
import { useOtherProfilesQuery } from "@/app/auth/auth.api";

import { Permission } from "@/shared/hooks/usePermission";

export const navigation = [
  {
    name: "KPIs",
    href: "/kpis",
    current: false,
    permission: Permission.ACCESS_KPI,
  },
  {
    name: "Companias",
    href: "/gyms",
    current: false,
    permission: Permission.COMPANY_ACCESS,
  },
  {
    name: "Filiales",
    href: "/branchs",
    current: true,
    permission: Permission.BRANCH_ACCESS_ALL_BRANCHES,
  },
  {
    name: "Usuarios",
    href: "/users",
    current: false,
    permission: Permission.USERS_ACCESS,
  },
  {
    name: "Fidelizacion",
    href: "/assigned",
    current: false,
    permission: Permission.LOYALTY_VIEW_COMPLETED_TASKS,
  },
  {
    name: "Accesos",
    href: "/access",
    current: false,
    permission: Permission.ACCESS_KPI,
  },
];

export const AdminLayout: FC<any> = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const otherProfilesQuery = useOtherProfilesQuery(undefined);
  const [profileListVisible, setProfileListVisible] = useState(false);

  return (
    <Fragment>
      <div
        className="flex flex-col"
        style={{ height: "100vh", width: "100vw" }}
      >
        <Navbar
          navigation={navigation}
          user={user}
          onChangeProfile={() => setProfileListVisible(true)}
        />
        <Outlet />
      </div>
      <ProfileListModal
        visible={profileListVisible}
        setVisible={setProfileListVisible}
        profiles={otherProfilesQuery.data ?? []}
        onSelectProfile={(profile) => {
          localStorage.setItem("accessToken", profile.accessToken);
          dispatch(setAccessToken({ accessToken: profile.accessToken }));
          setProfileListVisible(false);
        }}
      />
    </Fragment>
  );
};
